module.exports = __webpack_public_path__ + "static/media/layout_bottom_image.fda552b5.svg";